import { render, staticRenderFns } from "./Ivr.vue?vue&type=template&id=d367aed2&scoped=true&"
import script from "./Ivr.vue?vue&type=script&lang=js&"
export * from "./Ivr.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d367aed2",
  null
  
)

export default component.exports